import React from 'react';
import Widget from './Widget';

const ChessWebServices = () => {
  return (
    <Widget 
      title="Chess Web Services"
      subtitle="create a chess website"
      icon={<img src="/images/Consulting.png" alt="Chess Technology Consulting" className="w-12 h-12 rounded-xl" />}
      link="https://chessweb.site"
    />
  );
};

export default ChessWebServices;